import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              Pawkit
            </Link>
            <p className="footer-tagline">
              Premium pet nutrition delivered to your doorstep
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-section">
              <h4>Shop</h4>
              <ul>
                <li><Link to="/shop">All Products</Link></li>
                <li><Link to="/shop?petType=dog">Dog Food</Link></li>
                <li><Link to="/shop?petType=cat">Cat Food</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Policies</h4>
              <ul>
                <li><Link to="/terms">Terms & Conditions</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/refund-policy">Refund Policy</Link></li>
                <li><Link to="/shipping-policy">Shipping Policy</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                <li><Link to="/track-order">Track Order</Link></li>
                <li><a href="mailto:support@pawkit.in">Contact Us</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Pawkit. All rights reserved.</p>
          <p className="footer-contact">
            <a href="mailto:support@pawkit.in">support@pawkit.in</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
